export default __webpack_public_path__ + "static/media/emotionDecH2.d0fb1c3e.png";